<template>
  <div class="logo">
    <router-link role="button" to="/">
      <article class="logo-wrapper" :variant="variant">
        <section class="logo-top">
          <div class="logo-line vertical" />
          <div class="logo-line" />
          <div class="logo-tip arc arc-top" />
        </section>
        <section class="logo-bottom">
          <div class="logo-line vertical" />
          <div class="logo-line" />
          <div class="logo-tip arc arc-bottom" />
        </section>
      </article>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      default: "primary",
    },
  },
};
</script>

<style lang="scss" scoped></style>
